import React, { useState, useEffect } from 'react';
import ChatBubble from '../Components/Chatbubble';
import MessageInput from '../Components/MessageInput';
import kumarAvatar from '../Assets/kumar-avatar.png';
import userAvatar from '../Assets/User-avatar.png';
import TypingDots from '../Components/TypingDots';
import { callOpenAI } from '../utils/openaiService';

const FutureSelf = () => {
  const [chatLog, setChatLog] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [goal, setGoal] = useState('');
  const [questionIndex, setQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [isFutureSelfReady, setIsFutureSelfReady] = useState(false);

  const questions = [
    '🧠 What’s your biggest motivation for choosing this path?',
    '⛅ What’s something you’re afraid might hold you back?',
    '💪 What are you most confident about right now?',
  ];

  useEffect(() => {
    setChatLog([
      {
        sender: 'ai',
        avatar: kumarAvatar,
        name: 'Kumar',
        message: `Yo 👋🏽 Wanna see a glimpse of your future?

Not the boring resume version… I’m talking about a *visual* version of you — thriving, confident, doing what you love.

Let’s create a vision of your future self. What’s the goal you’re working towards right now? 🎯`,
      },
    ]);
  }, []);

  const handleUserInput = async (text) => {
    setIsTyping(true);

    const userMsg = {
      sender: 'user',
      avatar: userAvatar,
      name: 'You',
      message: text,
    };

    const updatedLog = [...chatLog, userMsg];
    setChatLog(updatedLog);

    // Step 1: Ask for goal
    if (!goal) {
      setGoal(text);
      setChatLog((prev) => [
        ...prev,
        {
          sender: 'ai',
          avatar: kumarAvatar,
          name: 'Kumar',
          message: `🔥 Love that! "${text}" is a powerful goal. Just a few quick questions before you meet your future self...`,
        },
        {
          sender: 'ai',
          avatar: kumarAvatar,
          name: 'Kumar',
          message: questions[0],
        },
      ]);
      setQuestionIndex(1);
      setIsTyping(false);
      return;
    }

    // Step 2: Ask reflection questions
    if (questionIndex > 0 && questionIndex <= questions.length) {
      const keys = ['motivation', 'fears', 'confidence'];
      const currentKey = keys[questionIndex - 1];
      setAnswers((prev) => ({ ...prev, [currentKey]: text }));

      if (questionIndex < questions.length) {
        // Ask next question
        setChatLog((prev) => [
          ...prev,
          {
            sender: 'ai',
            avatar: kumarAvatar,
            name: 'Kumar',
            message: questions[questionIndex],
          },
        ]);
        setQuestionIndex((prev) => prev + 1);
        setIsTyping(false);
        return;
      }

      // Step 3: All reflection questions done
      setIsFutureSelfReady(true);
      setQuestionIndex(questionIndex + 1);

      const contextPrompt = `My goal is to become a ${goal}. Here’s what I shared:\n\nMotivation: ${answers.motivation}\nFears: ${answers.fears}\nConfidence: ${text}`;

      setChatLog((prev) => [
        ...prev,
        {
          sender: 'ai',
          avatar: kumarAvatar,
          name: 'Kumar',
          message: `🔮 Hold on... your future self is arriving in 3... 2... 1...`,
        },
        {
          sender: 'ai',
          avatar: kumarAvatar,
          name: 'Kumar',
          message: `💫 Take a deep breath. You’re about to meet *you* from the future.`,
        },
      ]);

      // Delay before showing future self
      setTimeout(async () => {
        const response = await callOpenAI({
          messages: [{ role: 'user', content: contextPrompt }],
          screenContext: 'Futureself',
          userGoal: goal,
        });

        setChatLog((prev) => [
          ...prev,
          {
            sender: 'ai',
            avatar: kumarAvatar,
            name: 'Your Future Self',
            message: response,
          },
        ]);
        setIsTyping(false);
      }, 1500);

      return;
    }

    // Step 4: Continue future self chat
    if (isFutureSelfReady) {
      const formattedChat = chatLog
        .filter((msg) => typeof msg.message === 'string')
        .map((msg) => ({
          role: msg.sender === 'ai' ? 'assistant' : 'user',
          content: msg.message,
        }));

      const response = await callOpenAI({
        messages: [...formattedChat, { role: 'user', content: text }],
        screenContext: 'Futureself',
        userGoal: goal,
      });

      setChatLog((prev) => [
        ...prev,
        {
          sender: 'ai',
          avatar: kumarAvatar,
          name: 'Your Future Self',
          message: response,
        },
        {
          sender: 'ai',
          avatar: kumarAvatar,
          name: 'Kumar',
          message: `💛 You can always return to this conversation. I’ll be here whenever you’re ready to chat again.`,
        },
      ]);

      setIsTyping(false);
    }
  };

  return (
    <div className="bg-white/80 backdrop-blur-md rounded-[30px] shadow-xl p-6 flex flex-col justify-between min-h-[75vh] w-full max-w-[950px] mx-auto">
      <div className="flex flex-col gap-6 overflow-y-auto flex-grow pr-2 h-full max-h-[70vh] custom-scroll">
        {chatLog.map((msg, idx) => (
          <ChatBubble
            key={idx}
            sender={msg.sender}
            avatar={msg.avatar}
            name={msg.name}
            message={msg.message}
          />
        ))}
        {isTyping && (
          <ChatBubble sender="ai" avatar={kumarAvatar} name="Kumar" message={<TypingDots />} />
        )}
      </div>

      <div className="mt-6">
        <MessageInput onSend={handleUserInput} />
      </div>
    </div>
  );
};

export default FutureSelf;
